__turbopack_context__.v({
  "card": "PortalEvents-module__f8oTYW__card",
  "grid": "PortalEvents-module__f8oTYW__grid",
  "occurrence": "PortalEvents-module__f8oTYW__occurrence",
  "occurrenceActions": "PortalEvents-module__f8oTYW__occurrenceActions",
  "occurrences": "PortalEvents-module__f8oTYW__occurrences",
  "timeRange": "PortalEvents-module__f8oTYW__timeRange",
});
